import {
  DataGrid,
  DataGridLabel,
  DataGridRow,
  DataGridValue,
} from "@/components/common/dataGrid";
import { getUserPermissionById } from "@/pages/admin/users/permissions/lib/queries";
import { useEffect, useState } from "react";

export const UserPermissionShow = ({ id }) => {
  const [userPermission, setUserPermission] = useState(null);

  const getUserPermission = async () => {
    setUserPermission(await getUserPermissionById(id));
  };

  useEffect(() => {
    getUserPermission();
  }, [id]);

  if (!userPermission) {
    //TODO: Implement notFound
    // notFound();
    return null;
  }

  return (
    <DataGrid>
      <DataGridRow>
        <DataGridLabel>Naam</DataGridLabel>
        <DataGridValue>{userPermission?.name ?? ""}</DataGridValue>
      </DataGridRow>

      <DataGridRow>
        <DataGridLabel>Omschrijving</DataGridLabel>
        <DataGridValue>{userPermission?.description ?? ""}</DataGridValue>
      </DataGridRow>
    </DataGrid>
  );
};
